"use strict";

exports.__esModule = true;
var _TimeContext = require("./TimeContext");
Object.keys(_TimeContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimeContext[key]) return;
  exports[key] = _TimeContext[key];
});
var _TimeContextLoader = require("./TimeContextLoader");
Object.keys(_TimeContextLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimeContextLoader[key]) return;
  exports[key] = _TimeContextLoader[key];
});